export default __webpack_public_path__ + "static/imgHomeMobile-e19df1a1538816ee435abad1ffbcf556.png";